import React, {
  createContext,
  PropsWithChildren,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

export enum settingsType {
  AUTO_REFRESH = "autoRefresh",
  MERCHANTS_SORT_BY = "merchantsSortBy",
  MERCHANTS_SORT_BY_ORDER = "merchantsSortByOrder",
  MERCHANTS_ONLY_SCHEDULED = "merchantsOnlyScheduled",
  COUPONS_UNIQUE_RESULTS = "couponsUniqueResults",
  COUPONS_APPLIED_FILTER = "couponsAppliedFilter",
  COUPONS_NOT_APPLICABLE_FILTER = "couponsNotApplicableFilter",
  COUPONS_ONLY_FAILED = "couponsOnlyFailed",
  COUPONS_CONFIRMED_FAILURE_FILTER = "couponsConfirmedFailureFilter",
  COUPONS_SYSTEM_ERROR_FILTER = "couponsSystemErrorFilter",
  COUPONS_CHECKOUT_TECHNOLOGY = "couponsCheckoutTechnology",
  COUPONS_MERCHANT_NAME = "couponsMerchantName",
  COUPONS_MERCHANT_URL = "couponsMerchantUrl",
  COUPONS_START_DATE = "couponsStartDate",
  COUPONS_END_DATE = "couponsEndDate",
  COUPONS_PUBLISHED_STATUS = "couponsPublishedStatus",
  COUPONS_RUN_TYPE = "couponsRunType",
  TASKS_CHECKOUT_TYPE = "tasksCheckoutType",
  TASKS_NO_COUPONS = "tasksNoCoupons",
  TASKS_START_DATE_FROM = "tasksStartDateFrom",
  TASKS_START_DATE_TO = "tasksStartDateTo",
  TASKS_RAN_SUCCESSFULLY = "tasksRanSuccessfully",

  // Kindred Live — Deals
  KINDRED_DEALS_PUBLISHED_STATUS = "kindredDealsPublishedStatus",
  KINDRED_DEALS_SUSPENDED = "kindredDealsSuspended",
  KINDRED_DEALS_SOURCE = "kindredDealsSource",
  KINDRED_DEALS_COUNTRY = "kindredDealsCountry",
  KINDRED_DEALS_CASHBACK_TYPE = "kindredDealsCashbackType",
  KINDRED_DEALS_DOMAIN = "kindredDealsDomain",
  KINDRED_DEALS_FEATURED = "kindredDealsFeatured",
  KINDRED_DEALS_TOP_BRANDS = "kindredDealsTopBrands",
  KINDRED_DEALS_BRAND_ID = "kindredDealsBrandId",
  KINDRED_DEALS_CAMPAIGN_ID = "kindredDealsCampaignId",
  KINDRED_DEALS_MERCHANT_ID = "kindredDealsMerchantId",
  KINDRED_DEALS_KEYWORDS = "kindredDealsKeywords",
  KINDRED_DEALS_ACTIVE_DOMAINS_ONLY = "kindredDealsActiveDomainsOnly",
  KINDRED_DEALS_ACTIVE = "kindredDealsActive",

  // Kindred Live — Coupons
  KINDRED_COUPONS_CODE = "kindredCouponsCode",
  KINDRED_COUPONS_BRAND_ID = "kindredCouponsBrandId",
  KINDRED_COUPONS_TOP_BRANDS = "kindredCouponsTopBrands",
  KINDRED_COUPONS_COUNTRY = "kindredCouponsCountry",
  KINDRED_COUPONS_PUBLISHED_STATUS = "kindredCouponsPublishedStatus",
  KINDRED_COUPONS_SOURCE = "kindredCouponsSource",
  KINDRED_COUPONS_DOMAIN = "kindredCouponsDomain",
  KINDRED_COUPONS_DOMAIN_MODE = "kindredCouponsDomainMode",
  KINDRED_COUPONS_VALIDATED_ONLY = "kindredCouponsValidatedOnly",
  KINDRED_COUPONS_ACTIVE = "kindredCouponsActive",
  KINDRED_COUPONS_COVERAGE = "kindredCouponsCoverage",

  // Kindred Live — Offers
  KINDRED_OFFERS_BRAND_ID = "kindredOffersBrandId",
  KINDRED_OFFERS_TOP_BRANDS = "kindredOffersTopBrands",
  KINDRED_OFFERS_COUNTRY = "kindredOffersCountry",
  KINDRED_OFFERS_PUBLISHED_STATUS = "kindredOffersPublishedStatus",
  KINDRED_OFFERS_SOURCE = "kindredOffersSource",
  KINDRED_OFFERS_DOMAIN = "kindredOffersDomain",
  KINDRED_OFFERS_DOMAIN_MODE = "kindredOffersDomainMode",
  KINDRED_OFFERS_VALIDATED_ONLY = "kindredOffersValidatedOnly",
  KINDRED_OFFERS_ACTIVE = "kindredOffersActive",

  // Kindred Live — Brands
  KINDRED_BRANDS_NAME = "kindredBrandsName",
  KINDRED_BRANDS_COUNTRY = "kindredBrandsCountry",
  KINDRED_BRANDS_TOP_BRANDS = "kindredBrandsTopBrands",
  KINDRED_BRANDS_DOMAIN = "kindredBrandsDomain",

  // Kindred Live — Non-Agentic Merchants
  KINDRED_NON_AGENTIC_BRAND_NAME = "kindredNonAgenticBrandName",
  KINDRED_NON_AGENTIC_COUNTRY = "kindredNonAgenticCountry",
  KINDRED_NON_AGENTIC_DOMAIN = "kindredNonAgenticDomain",
  KINDRED_NON_AGENTIC_SOURCE = "kindredNonAgenticSource",

  // Affiliate Products
  AP_DISCOVERY_SEARCH = "apDiscoverySearch",
  AP_DISCOVERY_NETWORK = "apDiscoveryNetwork",
  AP_DISCOVERY_DOMAIN = "apDiscoveryDomain",
  AP_CATEGORIES_NETWORK = "apCategoriesNetwork",
  AP_CATEGORIES_SEARCH = "apCategoriesSearch",
  AP_CATEGORIES_DOMAIN = "apCategoriesDomain",
  AP_PRODUCTS_NETWORK = "apProductsNetwork",
  AP_PRODUCTS_ADVERTISER_ID = "apProductsAdvertiserId",
  AP_PRODUCTS_DOMAIN = "apProductsDomain",
  AP_PRODUCTS_CATEGORY = "apProductsCategory",
  AP_PRODUCTS_SEARCH = "apProductsSearch",
  AP_PRODUCTS_MANUFACTURER = "apProductsManufacturer",
  AP_PRODUCTS_COUNTRY = "apProductsCountry",
  AP_MERCHANT_DOMAIN = "apMerchantDomain",

  // QA Review Lists
  QA_LISTS_SEARCH = "qaListsSearch",
  QA_LISTS_ASSIGNEE = "qaListsAssignee",
  QA_LISTS_SORT_BY = "qaListsSortBy",
  QA_REVIEW_SEARCH = "qaReviewSearch",
  QA_REVIEW_COUNTRY = "qaReviewCountry",
  QA_REVIEW_UNTESTED_ONLY = "qaReviewUntestedOnly",
  QA_REVIEW_NOT_TESTED_DAYS = "qaReviewNotTestedDays",

  // Work Pipeline
  WORK_PIPELINE_STAGE = "workPipelineStage",
  WORK_PIPELINE_CLAIMED = "workPipelineClaimed",
  WORK_PIPELINE_ASSIGNEE = "workPipelineAssignee",
  WORK_PIPELINE_COUNTRY = "workPipelineCountry",
  WORK_PIPELINE_SEARCH = "workPipelineSearch",
  WORK_PIPELINE_LIST = "workPipelineList",
  COUPON_PERFORMANCE_AUTO_REFRESH = "couponPerformanceAutoRefresh",

  // Basket Testing
  BASKET_RESPONSE_MODE = "basketResponseMode",

  // Session Runs
  SESSION_RUNS_EXCLUDED_STATUSES = "sessionRunsExcludedStatuses",

  // List search memory (per-list: was a search run, and on which page)
  LIST_SEARCH_MEMORY = "listSearchMemory",
}

const SETTINGS_STORAGE_KEY = "app_settings";

// Define types for each setting
type SettingsValueTypes = {
  [settingsType.AUTO_REFRESH]: boolean;
  [settingsType.MERCHANTS_SORT_BY]: string;
  [settingsType.MERCHANTS_SORT_BY_ORDER]: "asc" | "desc";
  [settingsType.MERCHANTS_ONLY_SCHEDULED]: boolean;
  [settingsType.COUPONS_UNIQUE_RESULTS]: boolean;
  [settingsType.COUPONS_APPLIED_FILTER]: string;
  [settingsType.COUPONS_NOT_APPLICABLE_FILTER]: string;
  [settingsType.COUPONS_ONLY_FAILED]: boolean;
  [settingsType.COUPONS_CONFIRMED_FAILURE_FILTER]: string;
  [settingsType.COUPONS_SYSTEM_ERROR_FILTER]: string;
  [settingsType.COUPONS_CHECKOUT_TECHNOLOGY]: string;
  [settingsType.COUPONS_MERCHANT_NAME]: string;
  [settingsType.COUPONS_MERCHANT_URL]: string;
  [settingsType.COUPONS_START_DATE]: string;
  [settingsType.COUPONS_END_DATE]: string;
  [settingsType.COUPONS_PUBLISHED_STATUS]: string;
  [settingsType.COUPONS_RUN_TYPE]: string;
  [settingsType.TASKS_CHECKOUT_TYPE]: string;
  [settingsType.TASKS_NO_COUPONS]: string;
  [settingsType.TASKS_START_DATE_FROM]: string;
  [settingsType.TASKS_START_DATE_TO]: string;
  [settingsType.TASKS_RAN_SUCCESSFULLY]: string;

  // Kindred Live — Deals
  [settingsType.KINDRED_DEALS_PUBLISHED_STATUS]: string;
  [settingsType.KINDRED_DEALS_SUSPENDED]: string;
  [settingsType.KINDRED_DEALS_SOURCE]: string;
  [settingsType.KINDRED_DEALS_COUNTRY]: string;
  [settingsType.KINDRED_DEALS_CASHBACK_TYPE]: string;
  [settingsType.KINDRED_DEALS_DOMAIN]: string;
  [settingsType.KINDRED_DEALS_FEATURED]: boolean;
  [settingsType.KINDRED_DEALS_TOP_BRANDS]: boolean;
  [settingsType.KINDRED_DEALS_BRAND_ID]: string;
  [settingsType.KINDRED_DEALS_CAMPAIGN_ID]: string;
  [settingsType.KINDRED_DEALS_MERCHANT_ID]: string;
  [settingsType.KINDRED_DEALS_KEYWORDS]: string;
  [settingsType.KINDRED_DEALS_ACTIVE_DOMAINS_ONLY]: boolean;
  [settingsType.KINDRED_DEALS_ACTIVE]: boolean;

  // Kindred Live — Coupons
  [settingsType.KINDRED_COUPONS_CODE]: string;
  [settingsType.KINDRED_COUPONS_BRAND_ID]: string;
  [settingsType.KINDRED_COUPONS_TOP_BRANDS]: boolean;
  [settingsType.KINDRED_COUPONS_COUNTRY]: string;
  [settingsType.KINDRED_COUPONS_PUBLISHED_STATUS]: string;
  [settingsType.KINDRED_COUPONS_SOURCE]: string;
  [settingsType.KINDRED_COUPONS_DOMAIN]: string;
  [settingsType.KINDRED_COUPONS_DOMAIN_MODE]: string;
  [settingsType.KINDRED_COUPONS_VALIDATED_ONLY]: boolean;
  [settingsType.KINDRED_COUPONS_ACTIVE]: boolean;
  [settingsType.KINDRED_COUPONS_COVERAGE]: string;

  // Kindred Live — Offers
  [settingsType.KINDRED_OFFERS_BRAND_ID]: string;
  [settingsType.KINDRED_OFFERS_TOP_BRANDS]: boolean;
  [settingsType.KINDRED_OFFERS_COUNTRY]: string;
  [settingsType.KINDRED_OFFERS_PUBLISHED_STATUS]: string;
  [settingsType.KINDRED_OFFERS_SOURCE]: string;
  [settingsType.KINDRED_OFFERS_DOMAIN]: string;
  [settingsType.KINDRED_OFFERS_DOMAIN_MODE]: string;
  [settingsType.KINDRED_OFFERS_VALIDATED_ONLY]: boolean;
  [settingsType.KINDRED_OFFERS_ACTIVE]: boolean;

  // Kindred Live — Brands
  [settingsType.KINDRED_BRANDS_NAME]: string;
  [settingsType.KINDRED_BRANDS_COUNTRY]: string;
  [settingsType.KINDRED_BRANDS_TOP_BRANDS]: boolean;
  [settingsType.KINDRED_BRANDS_DOMAIN]: string;

  // Kindred Live — Non-Agentic Merchants
  [settingsType.KINDRED_NON_AGENTIC_BRAND_NAME]: string;
  [settingsType.KINDRED_NON_AGENTIC_COUNTRY]: string;
  [settingsType.KINDRED_NON_AGENTIC_DOMAIN]: string;
  [settingsType.KINDRED_NON_AGENTIC_SOURCE]: string;

  // Affiliate Products
  [settingsType.AP_DISCOVERY_SEARCH]: string;
  [settingsType.AP_DISCOVERY_NETWORK]: string;
  [settingsType.AP_DISCOVERY_DOMAIN]: string;
  [settingsType.AP_CATEGORIES_NETWORK]: string;
  [settingsType.AP_CATEGORIES_SEARCH]: string;
  [settingsType.AP_CATEGORIES_DOMAIN]: string;
  [settingsType.AP_PRODUCTS_NETWORK]: string;
  [settingsType.AP_PRODUCTS_ADVERTISER_ID]: string;
  [settingsType.AP_PRODUCTS_DOMAIN]: string;
  [settingsType.AP_PRODUCTS_CATEGORY]: string;
  [settingsType.AP_PRODUCTS_SEARCH]: string;
  [settingsType.AP_PRODUCTS_MANUFACTURER]: string;
  [settingsType.AP_PRODUCTS_COUNTRY]: string;
  [settingsType.AP_MERCHANT_DOMAIN]: string;

  // QA Review Lists
  [settingsType.QA_LISTS_SEARCH]: string;
  [settingsType.QA_LISTS_ASSIGNEE]: string;
  [settingsType.QA_LISTS_SORT_BY]: string;
  [settingsType.QA_REVIEW_SEARCH]: string;
  [settingsType.QA_REVIEW_COUNTRY]: string;
  [settingsType.QA_REVIEW_UNTESTED_ONLY]: boolean;
  [settingsType.QA_REVIEW_NOT_TESTED_DAYS]: string;

  // Work Pipeline
  [settingsType.WORK_PIPELINE_STAGE]: string;
  [settingsType.WORK_PIPELINE_CLAIMED]: string;
  [settingsType.WORK_PIPELINE_ASSIGNEE]: string;
  [settingsType.WORK_PIPELINE_COUNTRY]: string;
  [settingsType.WORK_PIPELINE_SEARCH]: string;
  [settingsType.WORK_PIPELINE_LIST]: string;
  [settingsType.COUPON_PERFORMANCE_AUTO_REFRESH]: boolean;

  // Basket Testing
  [settingsType.BASKET_RESPONSE_MODE]: "friendly" | "raw";

  // Session Runs
  [settingsType.SESSION_RUNS_EXCLUDED_STATUSES]: string;

  // List search memory
  [settingsType.LIST_SEARCH_MEMORY]: string;
};

// Type helper for settings options
export interface ISettingsOption<K extends settingsType> {
  label: K;
  value: SettingsValueTypes[K];
}

// Update settings options with proper typing
export const settingsOptions = [
  { label: settingsType.AUTO_REFRESH, value: false },
  { label: settingsType.MERCHANTS_SORT_BY, value: "createdAt" },
  { label: settingsType.MERCHANTS_SORT_BY_ORDER, value: "desc" },
  { label: settingsType.MERCHANTS_ONLY_SCHEDULED, value: true },
  { label: settingsType.COUPONS_UNIQUE_RESULTS, value: true },
  { label: settingsType.COUPONS_APPLIED_FILTER, value: "" },
  { label: settingsType.COUPONS_NOT_APPLICABLE_FILTER, value: "" },
  { label: settingsType.COUPONS_ONLY_FAILED, value: false },
  { label: settingsType.COUPONS_CONFIRMED_FAILURE_FILTER, value: "" },
  { label: settingsType.COUPONS_SYSTEM_ERROR_FILTER, value: "" },
  { label: settingsType.COUPONS_CHECKOUT_TECHNOLOGY, value: "" },
  { label: settingsType.COUPONS_MERCHANT_NAME, value: "" },
  { label: settingsType.COUPONS_MERCHANT_URL, value: "" },
  { label: settingsType.COUPONS_START_DATE, value: "" },
  { label: settingsType.COUPONS_END_DATE, value: "" },
  { label: settingsType.COUPONS_PUBLISHED_STATUS, value: "" },
  { label: settingsType.TASKS_CHECKOUT_TYPE, value: "" },
  { label: settingsType.TASKS_NO_COUPONS, value: "all" },
  { label: settingsType.TASKS_START_DATE_FROM, value: "" },
  { label: settingsType.TASKS_START_DATE_TO, value: "" },
  { label: settingsType.TASKS_RAN_SUCCESSFULLY, value: "all" },

  // Kindred Live — Deals
  { label: settingsType.KINDRED_DEALS_PUBLISHED_STATUS, value: "" },
  { label: settingsType.KINDRED_DEALS_SUSPENDED, value: "" },
  { label: settingsType.KINDRED_DEALS_SOURCE, value: "" },
  { label: settingsType.KINDRED_DEALS_COUNTRY, value: "" },
  { label: settingsType.KINDRED_DEALS_CASHBACK_TYPE, value: "" },
  { label: settingsType.KINDRED_DEALS_DOMAIN, value: "" },
  { label: settingsType.KINDRED_DEALS_FEATURED, value: false },
  { label: settingsType.KINDRED_DEALS_TOP_BRANDS, value: false },
  { label: settingsType.KINDRED_DEALS_BRAND_ID, value: "" },
  { label: settingsType.KINDRED_DEALS_CAMPAIGN_ID, value: "" },
  { label: settingsType.KINDRED_DEALS_MERCHANT_ID, value: "" },
  { label: settingsType.KINDRED_DEALS_KEYWORDS, value: "" },
  { label: settingsType.KINDRED_DEALS_ACTIVE_DOMAINS_ONLY, value: false },
  { label: settingsType.KINDRED_DEALS_ACTIVE, value: false },

  // Kindred Live — Coupons
  { label: settingsType.KINDRED_COUPONS_CODE, value: "" },
  { label: settingsType.KINDRED_COUPONS_BRAND_ID, value: "" },
  { label: settingsType.KINDRED_COUPONS_TOP_BRANDS, value: false },
  { label: settingsType.KINDRED_COUPONS_COUNTRY, value: "" },
  { label: settingsType.KINDRED_COUPONS_PUBLISHED_STATUS, value: "" },
  { label: settingsType.KINDRED_COUPONS_SOURCE, value: "" },
  { label: settingsType.KINDRED_COUPONS_DOMAIN, value: "" },
  { label: settingsType.KINDRED_COUPONS_DOMAIN_MODE, value: "both" },
  { label: settingsType.KINDRED_COUPONS_VALIDATED_ONLY, value: false },
  { label: settingsType.KINDRED_COUPONS_ACTIVE, value: false },
  { label: settingsType.KINDRED_COUPONS_COVERAGE, value: "" },

  // Kindred Live — Offers
  { label: settingsType.KINDRED_OFFERS_BRAND_ID, value: "" },
  { label: settingsType.KINDRED_OFFERS_TOP_BRANDS, value: false },
  { label: settingsType.KINDRED_OFFERS_COUNTRY, value: "" },
  { label: settingsType.KINDRED_OFFERS_PUBLISHED_STATUS, value: "" },
  { label: settingsType.KINDRED_OFFERS_SOURCE, value: "" },
  { label: settingsType.KINDRED_OFFERS_DOMAIN, value: "" },
  { label: settingsType.KINDRED_OFFERS_DOMAIN_MODE, value: "both" },
  { label: settingsType.KINDRED_OFFERS_VALIDATED_ONLY, value: false },
  { label: settingsType.KINDRED_OFFERS_ACTIVE, value: false },

  // Kindred Live — Brands
  { label: settingsType.KINDRED_BRANDS_NAME, value: "" },
  { label: settingsType.KINDRED_BRANDS_COUNTRY, value: "" },
  { label: settingsType.KINDRED_BRANDS_TOP_BRANDS, value: false },
  { label: settingsType.KINDRED_BRANDS_DOMAIN, value: "" },

  // Kindred Live — Non-Agentic Merchants
  { label: settingsType.KINDRED_NON_AGENTIC_BRAND_NAME, value: "" },
  { label: settingsType.KINDRED_NON_AGENTIC_COUNTRY, value: "" },
  { label: settingsType.KINDRED_NON_AGENTIC_DOMAIN, value: "" },
  { label: settingsType.KINDRED_NON_AGENTIC_SOURCE, value: "" },

  // Affiliate Products
  { label: settingsType.AP_DISCOVERY_SEARCH, value: "" },
  { label: settingsType.AP_DISCOVERY_NETWORK, value: "" },
  { label: settingsType.AP_DISCOVERY_DOMAIN, value: "" },
  { label: settingsType.AP_CATEGORIES_NETWORK, value: "" },
  { label: settingsType.AP_CATEGORIES_SEARCH, value: "" },
  { label: settingsType.AP_CATEGORIES_DOMAIN, value: "" },
  { label: settingsType.AP_PRODUCTS_NETWORK, value: "" },
  { label: settingsType.AP_PRODUCTS_ADVERTISER_ID, value: "" },
  { label: settingsType.AP_PRODUCTS_DOMAIN, value: "" },
  { label: settingsType.AP_PRODUCTS_CATEGORY, value: "" },
  { label: settingsType.AP_PRODUCTS_SEARCH, value: "" },
  { label: settingsType.AP_PRODUCTS_MANUFACTURER, value: "" },
  { label: settingsType.AP_PRODUCTS_COUNTRY, value: "" },
  { label: settingsType.AP_MERCHANT_DOMAIN, value: "" },

  // QA Review Lists
  { label: settingsType.QA_LISTS_SEARCH, value: "" },
  { label: settingsType.QA_LISTS_ASSIGNEE, value: "" },
  { label: settingsType.QA_LISTS_SORT_BY, value: "createdAt" },
  { label: settingsType.QA_REVIEW_SEARCH, value: "" },
  { label: settingsType.QA_REVIEW_COUNTRY, value: "" },
  { label: settingsType.QA_REVIEW_UNTESTED_ONLY, value: false },
  { label: settingsType.QA_REVIEW_NOT_TESTED_DAYS, value: "" },

  // Work Pipeline
  { label: settingsType.WORK_PIPELINE_STAGE, value: "" },
  { label: settingsType.WORK_PIPELINE_CLAIMED, value: "" },
  { label: settingsType.WORK_PIPELINE_ASSIGNEE, value: "" },
  { label: settingsType.WORK_PIPELINE_COUNTRY, value: "" },
  { label: settingsType.WORK_PIPELINE_SEARCH, value: "" },
  { label: settingsType.WORK_PIPELINE_LIST, value: "" },
  { label: settingsType.COUPON_PERFORMANCE_AUTO_REFRESH, value: true },

  // Basket Testing
  { label: settingsType.BASKET_RESPONSE_MODE, value: "friendly" as const },

  // Session Runs
  {
    label: settingsType.SESSION_RUNS_EXCLUDED_STATUSES,
    value: "no_coupons,no_template",
  },

  // List search memory
  { label: settingsType.LIST_SEARCH_MEMORY, value: "{}" },
] as const;

interface SettingsContextType {
  settingsState: Array<{ label: settingsType; value: any }>;
  setSetting: <K extends settingsType>(
    label: K,
    value: SettingsValueTypes[K]
  ) => void;
}

const SettingsContext = createContext<SettingsContextType | undefined>(
  undefined
);

export const SettingsProvider = ({ children }: PropsWithChildren) => {
  const [settingsState, setSettingsState] = useState<
    Array<{ label: settingsType; value: any }>
  >(() => {
    const storedSettings = localStorage.getItem(SETTINGS_STORAGE_KEY);
    if (storedSettings) {
      try {
        const parsedSettings = JSON.parse(storedSettings);
        const mergedSettings: Array<{ label: settingsType; value: any }> = [
          ...settingsOptions,
        ];

        parsedSettings.forEach(
          (storedSetting: { label: settingsType; value: any }) => {
            const index = mergedSettings.findIndex(
              (s) => s.label === storedSetting.label
            );
            if (index !== -1) {
              mergedSettings[index] = storedSetting;
            }
          }
        );

        return mergedSettings;
      } catch (e) {
        console.error("Failed to parse stored settings:", e);
        return [...settingsOptions];
      }
    }
    return [...settingsOptions] as Array<{ label: settingsType; value: any }>;
  });

  const setSetting = useCallback(
    <K extends settingsType>(label: K, value: SettingsValueTypes[K]) => {
      setSettingsState((prevState) => {
        const newSettings = prevState.map((setting) =>
          setting.label === label ? { ...setting, value } : setting
        );
        localStorage.setItem(SETTINGS_STORAGE_KEY, JSON.stringify(newSettings));
        return newSettings;
      });
    },
    []
  );

  const value = useMemo(
    () => ({ settingsState, setSetting }),
    [settingsState, setSetting]
  );

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = <K extends settingsType>(label: K) => {
  const context = useContext(SettingsContext);

  if (!context) {
    throw new Error("useSettings must be used within SettingsProvider");
  }

  const { settingsState, setSetting } = context;

  const value = useMemo(() => {
    const setting = settingsState.find((s) => s.label === label);
    return setting
      ? setting.value
      : (undefined as unknown as SettingsValueTypes[K]);
  }, [label, settingsState]);

  const setValue = useCallback(
    (newValue: SettingsValueTypes[K]) => {
      setSetting(label, newValue);
    },
    [label, setSetting]
  );

  return [value, setValue] as const;
};
